import { UnregisteredStudentsUIProvider } from "./UnregisteredStudentsUIContext";
import { UnregisteredStudentsCard } from "./UnregisteredStudentsCard";

export function UnregisteredStudentsPage({ history }) {
  const studentsUIEvents = {
    openNewStudentPage: () => {
      history.push("/okul-disi-ogrenciler/ekle");
    },
    openEditStudentPage: (id) => {
      history.push(`/okul-disi-ogrenciler/duzenle/${id}`);
    },
    openFinalRegistrationPage: (id) => {
      history.push(`/ogrenciler/kesin-kayit-yap/${id}`);
    },
  };
  
  return (
    <UnregisteredStudentsUIProvider studentsUIEvents={studentsUIEvents}>
      <UnregisteredStudentsCard />
    </UnregisteredStudentsUIProvider>
 );
}